import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { StructureService, SanService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
	currencies?: any;
	commission_percentage?: number;
}

const FREQUENCIES = Constants.FREQUENCIES;

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			state_id: '',
			city_id: '',
			amount: '',
			dues: '',
			frequency: '',
			quantity_persons: '',
			days_max: '0',
			points: '0',
			days_or_weeks: '',
			type_id: Constants.SAN_TYPES.BASIC,
			commission_percentage: this.props.commission_percentage || '0',
			// @ts-ignore
			currency_id: this.props.currencies[0].id || '',
			modality_id: Constants.SAN_MODALITIES.NEW_MODEL,
			initial_payment: '',
			country_id: Constants.COUNTRIES.VZLA
		},
		states: [],
		cities: [],
		types: []
	}

	componentDidMount() {
		this.load();

		if (this.props.item) {
			const item: any = this.props.item;

			this.setState({
				form: {
					...this.state.form,
					state_id: item.state_id || '',
					city_id: item.city_id || '',
					amount: item.amount || '',
					dues: item.dues || '',
					frequency: item.frequency || '',
					quantity_persons: item.quantity_persons || '',
					days_max: item.days_max || '0',
					points: item.points || '0',
					days_or_weeks: item.days_or_weeks || '',
					type_id: item.type_id || '',
					commission_percentage: item.commission_percentage || '0',
					currency_id: item?.currency_id || '',
					modality_id: item?.modality_id || Constants.SAN_MODALITIES.NEW_MODEL,
					initial_payment: item?.initial_payment || '',
					country_id: item?.country_id || Constants.COUNTRIES.VZLA
				}
			},() => this.loadCities());
		}
	}

	load = async () => {
		const res: any = await SanService.admin.getStates({
			country_id: this.state.form.country_id
		});
		this.setState({
			states: res.states,
			types: res.types || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.props.item) {
			await StructureService.admin.update({
				...this.state.form,
				san_id: this.props.item?.id
			});
			this.props.onClose();
			Globals.showSuccess("Se ha modificado el SAN estructurado");
		}
		else {
			await StructureService.admin.create({
				...this.state.form
			});
			this.props.onClose();
			Globals.showSuccess("Se ha registrado el SAN estructurado");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	loadCities = async () => {
		const res: any = await SanService.admin.getCities({
			state_id: this.state.form.state_id
		});
		this.setState({
			cities: res.cities
		});
	}
	
	render() {
		const currency = this.props.currencies?.find((i: any) => i.id == this.state.form.currency_id);

		return (
			<div id="modal-create-san">
				<form onSubmit={ this.submit }>
					<div className="row">
						{
							!this.props.item ? (
								<>
									<div className="col-md-6">
										<Select
											label="País"
											name="country_id"
											onChange={ (e: any) => this.change(e,() => {
												if (this.state.form.country_id == Constants.COUNTRIES.VZLA) {
													this.setState({
														form: {
															...this.state.form,
															currency_id: Constants.CURRENCIES.USD
														}
													});
												}
												else if (this.state.form.country_id == Constants.COUNTRIES.COL) {
													this.setState({
														form: {
															...this.state.form,
															currency_id: Constants.CURRENCIES.COP,
															modality_id: Constants.SAN_MODALITIES.NEW_MODEL
														}
													});
												}

												this.load();
											}) }
											value={ this.state.form.country_id }
											options={ [
												{ value: Constants.COUNTRIES.VZLA.toString(), label: 'Venezuela' },
												{ value: Constants.COUNTRIES.COL.toString(), label: 'Colombia' },
											] } />
									</div>
									<div className="col-md-6">
										{
											this.state.form.country_id == Constants.COUNTRIES.VZLA && (
												<Select
													label="Modalidad"
													name="modality_id"
													onChange={ this.change }
													value={ this.state.form.modality_id }
													options={ [
														{ value: Constants.SAN_MODALITIES.CLASSIC.toString(), label: 'Premium' },
														{ value: Constants.SAN_MODALITIES.NEW_MODEL.toString(), label: 'Juntos' },
													] } />
											)
										}
									</div>
								</>
							) : (
								<div className="col-md-12">
									<p className="frequency-label">Modalidad: { this.props.item?.modality?.name }</p>
								</div>
							)
						}
						<div className="col-md-6">
							<Select
								placeholder="Seleccionar"
								label="Moneda"
								name="currency_id"
								onChange={ this.change }
								value={ this.state.form.currency_id }
								options={ this.props.currencies?.filter((i: any) => {
									if (this.state.form.country_id == Constants.COUNTRIES.VZLA) {
										return i.id == Constants.CURRENCIES.USD || i.id == Constants.CURRENCIES.EUR;
									}
									else if (this.state.form.country_id == Constants.COUNTRIES.COL) {
										return i.id == Constants.CURRENCIES.COP;
									}
									else {
										return false;
									}
								}).map((item: any) => {
									return {
										value: item.id,
										label: item.name
									}
								}) } />
						</div>
						<div className={ `col-md-${ this.state.form.modality_id != Constants.SAN_MODALITIES.NEW_MODEL ? '4' : '6' }` }>
							<Select
								placeholder="Seleccionar"
								label="Estado (Opcional)"
								name="state_id"
								onChange={ (e: any) => this.change(e,async () => {
									await this.setState({
										form: {
											...this.state.form,
											city_id: ''
										}
									});
									this.loadCities();
								}) }
								value={ this.state.form.state_id }
								options={ this.state.states.map((item: any) => {
									return {
										value: item.id,
										label: item.name
									}
								}) } />
						</div>
						<div className="col-md-6">
							<Select
								disabled={ !this.state.form.state_id }
								placeholder="Seleccionar"
								label="Ciudad (Opcional)"
								name="city_id"
								onChange={ (e: any) => this.change(e) }
								value={ this.state.form.city_id }
								options={ this.state.cities.map((item: any) => {
									return {
										value: item.id,
										label: item.name
									}
								}) } />
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								value={ this.state.form.amount }
								name="amount"
								placeholder="Monto"
								label={ `Monto del San (${ currency?.name })` }
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								value={ this.state.form.dues }
								name="dues"
								placeholder="Monto"
								label={ `Cuota a cancelar (${ currency?.name })` }
								onChange={ (e: any) => this.change(e,() => {
									if (this.state.form.country_id == Constants.COUNTRIES.COL) {
										this.setState({
											form: {
												...this.state.form,
												initial_payment: e.target.value
											}
										});
									}
								}) } />
						</div>
						<div className="col-md-12">
							<p className="frequency-label">Frecuencia</p>
						</div>
						<div className="col-md-12">
							<div className="container-checks">
								<div className="item-check" onClick={ () => {
									this.setState({
										form: {
											...this.state.form,
											frequency: FREQUENCIES.WEEK
										}
									});
								} }>
									{/*
									// @ts-ignore */}
									<div className={ `check ${ this.state.form.frequency == FREQUENCIES.WEEK ? 'active' : '' }` }></div>
									<p>Semanal</p>
								</div>
								{/*<div className="item-check" onClick={ () => {
									this.setState({
										form: {
											...this.state.form,
											frequency: FREQUENCIES.MONTH
										}
									});
								} }>
									<div className={ `check ${ this.state.form.frequency == FREQUENCIES.MONTH ? 'active' : '' }` }></div>
									<p>Mensual</p>
								</div>*/}
								<div className="item-check" onClick={ () => {
									this.setState({
										form: {
											...this.state.form,
											frequency: FREQUENCIES.BIWEEK
										}
									});
								} }>
									{/*
									// @ts-ignore */}
									<div className={ `check ${ this.state.form.frequency == FREQUENCIES.BIWEEK ? 'active' : '' }` }></div>
									<p>Quincenal</p>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<Input
								type="number"
								value={ this.state.form.days_or_weeks }
								name="days_or_weeks"
								placeholder="0"
								label="Nº de semanas/meses/quincenas"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								type="number"
								value={ this.state.form.quantity_persons }
								name="quantity_persons"
								placeholder="0"
								label="Nº de personas participantes"
								onChange={ (e: any) => this.change(e) } />
						</div>
						{
							this.state.form.modality_id == Constants.SAN_MODALITIES.CLASSIC ? (
								<div className="col-md-6">
									<Input
										type="percentage"
										value={ this.state.form.commission_percentage }
										name="commission_percentage"
										placeholder="0"
										label="Porcentaje de ganancia"
										onChange={ (e: any) => this.change(e) } />
								</div>
							) :  (
								<div className="col-md-6">
									{
										this.state.form.country_id == Constants.COUNTRIES.COL ? (
											<>
												<p className="initial_payment"><strong>Pago Inicial:</strong> { Globals.formatMiles(this.state.form.initial_payment) }</p>
											</>
										) : (
											<>
												<Input
													type="initial_payment"
													value={ this.state.form.initial_payment }
													name="initial_payment"
													placeholder="0"
													label="Pago Inicial"
													onChange={ (e: any) => this.change(e) } />
											</>
										)
									}
								</div>
							)
						}
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;